<script setup lang="ts">
import { useVModel } from '@vueuse/core' // Import useVModel
import { cn } from '~/lib/utils'
import { computed, type HTMLAttributes } from 'vue'

// Define emits for v-model
const emits = defineEmits(['update:modelValue'])

interface InputProps {
  type?: string
  placeholder?: string
  modelValue?: string // Changed from 'value' to 'modelValue'
  disabled?: boolean
  required?: boolean
  class?: HTMLAttributes['class']
  [key: string]: any
}

const props = withDefaults(defineProps<InputProps>(), {
  type: 'text',
  modelValue: '', // Provide a default for modelValue
})

// Use useVModel for easier v-model handling (optional but clean)
const modelValue = useVModel(props, 'modelValue', emits)

// Remove delegatedProps computation as we'll bind explicitly
// const delegatedProps = computed(() => {
//   const { class: _, modelValue: __, ...delegated } = props 
//   return delegated
// })
</script>

<template>
  <input
    v-model="modelValue"
    :type="props.type"
    :placeholder="props.placeholder"
    :disabled="props.disabled"
    :required="props.required"
    :class="
      cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        props.class,
      )
    "
  />
</template>
